import bowser from 'bowser';

const minVersions = {
    chrome: '>62',
    msedge: '>15',
    firefox: '>57',
    safari: '>11',
    windows: {
        'Xueersi homework/4.3.3.0 QT': '>=5.7.0'
    },
    macOs: {
        'chrome': '>56'
    }
};
const parseUa = bowser.getParser(window.navigator.userAgent);
const parseOs = parseUa.parsedResult.browser.name;
/**
 * Helper function to determine if the browser is supported at all.
 * @returns {boolean} False if the platform is definitely not supported.
 */
const supportedBrowser = () => {
    if (
        parseOs === 'Internet Explorer'
    ) {
        return false;
    }
    return true;
};

/**
 * Helper function to determine if the browser meets the minimum recommended version
 * @returns {boolean} False if the browser isn't a recommended browser, or doesn't
 * meet the minimum version for recommended browsers.
 * NOTE: uses strict_mode==true so that any browser not listed in the minVersions
 *   always returns false
 */

// 教师端
const ua = window.navigator.userAgent.toLowerCase();

function isTeacherEnd () {
    return (ua.indexOf('xescef') === -1 && ua.indexOf('qtwebengine') > -1) || (/(jzh)/i.test(ua) && /pc\/client/i.test(ua))
  }

function isCorrectEnd () {
    return ua.indexOf('homework_correct_app') > -1 || ua.indexOf('homework') > -1 || ua.indexOf('correct') > -1
  }

const recommendedBrowser = () => {
    if(parseOs.startsWith('Xueersi') || isTeacherEnd() || isCorrectEnd() ){
        return true
    }
    return parseUa.satisfies(minVersions)
};
const downloadChrome = () => {
    let url = 'http://www.google.cn/chrome/';
    // if (bowser.windows) {
    //     url ='https://icourse.xesimg.com/programme/static/soft/chrome/chrome-75.exe';
    // }

    // if (bowser.mac) {
    //     url ='https://icourse.xesimg.com/programme/static/soft/chrome/chrome-75.dmg';
    // }
    window.open(url, 'download');
};

export {
    supportedBrowser as default,
    recommendedBrowser,
    downloadChrome
};
